<template>

    <div>
        <div id="p-S" class="p-title w588 flex items-center justify-center">
            <img class="img-p-name" :src="luckyboxStore.getAsset('images/event/2026luckybox/W-pr-name-s.png')" alt="好聰敏3益生菌"/>
        </div>
        <div class="box-style max-w-1250">
            <div class="product-list">
                <div class="directions-BG">
                    <a :href="luckyboxStore.getAsset('/images/event/p-s-jump.jpg')" @click.prevent="handlePopup">
                        <img class="mo-show" :src="luckyboxStore.getAsset('/images/event/2026luckybox/mo-title-p-s_03_03.png')" alt="三餐外食、飲食不均？嚴選雙孢活菌＋專利酵素，幫助消化促進分解，保衛您的消化健康"/>
                        <img class="pc-show w969" :src="luckyboxStore.getAsset('/images/event/2026luckybox/p-content_03.png')" alt="三餐外食、飲食不均？嚴選雙孢活菌＋專利酵素，幫助消化促進分解，保衛您的消化健康"/>
                    </a>
                </div>

                <Placeholder v-if="!hasBundles()" :count="3" width="100%" height="300px" />

                <ul class="grid grid-1-2-3 gap-05rem" v-else>

                    <li class="product-list__item" v-for="(bundle, bid) in items" :key="bundle.id">
                        <div class="item-style">
                            <div class="gold-circle">
                                <div class="number-befor text-3xl font-semibold">{{ bundle.base_qty ?? '--' }}</div>
                            </div>
                            <div class="mo-w280">
                                <img class="margin-t25" :src="luckyboxStore.getAsset('images/event/2026luckybox/S-probiotics.png')" :alt="`bundle?.title`"/>
                                <img class="m-cut-20" :src="luckyboxStore.getAsset(bundle?.cover_price)" :alt="`${toNumeric(bundle?.price)}福箱`" />
                            </div>
                            <div class="flex flex-col">
                                <div class="text-center m-bottom-05">
                                    <span class="original-P text-xl"><span class="line-through">{{ toNumeric(bundle.price_origin) }}</span></span>
                                    &ensp;
                                    <span class="average">平均<span>{{ toNumeric(bundle.price_avg) }}</span>/盒</span>
                                </div>
                                <div class="text-sm txt-orange text-center">口味:原味</div>
                            </div>
                        </div>
                        <div class="text-center" v-if="campaign?.is_active">
                            <button class="add-to-cart-btn red-btn radius-100 font-semibold"
                                :loading="states.is_loading"
                                :disabled="states.is_loading || !isItemAvailable(bid)"
                                :class="{
                                    'not-buy adding': states.is_loading,
                                    'not-buy': !isItemAvailable(bid)
                                }"
                                @click.prevent="handleAddBundleToCart($event, bid)">
                                    <span v-if="!isItemAvailable(bid)">已售完</span>
                                    <span v-else-if="states.is_loading">處理中...</span>
                                    <span v-else>加入購物車</span>
                            </button>
                        </div>
                    </li>

                </ul>
            </div>
        </div>
    </div>

</template>

<style lang="scss" scope>
.not-buy,
.add-to-cart-btn[disabled] {
    filter: grayscale(1);
    opacity: 0.4;
    cursor: not-allowed!important;
    pointer-events: none;
}
</style>

<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { toNumeric } from '../../../composables/utils';
import { useGlobalStore } from '../../../stores/useGlobalStore';
import { useLuckyboxStore } from '../../../stores/useLuckyboxStore';
import Placeholder from './placeholder.vue';

const emits = defineEmits(['popup']);

const globalStore = useGlobalStore();
const luckyboxStore = useLuckyboxStore();

const { is_loading } = storeToRefs(globalStore);
const { cart, bundles, expanded, campaign, states } = storeToRefs(luckyboxStore);

const hasBundles = () => {
    if (!items?.value) {
        return false;
    }
    return Object.keys(items.value).length > 0;
};

const items = computed(() => {
    return luckyboxStore.getBundleByType('s-probiotic', bundles.value) ?? [];
});

const isItemAvailable = (bid) => {
    const rows = items.value?.[bid]?.items ?? {};

    if (!rows || Object.keys(rows).length === 0) {
        return false;
    }
    return Object.values(rows).every(item => item?.is_available);
};

const handleAddBundleToCart = async(e, bid) => {
    await luckyboxStore.addBundleToCart(bid, false);
};

const handlePopup = (e) => {
    const src = e.currentTarget.getAttribute('href');
    if (src) {
        emits('popup', src);
    }
};

</script>
